import React from "react";
import { useSelector } from "react-redux";
import { LinkAction, BasicAction } from "widgets/ActionMenu";
import { legacyPreviewVersion, previewVersion } from "widgets/grid/cells/CreativeActionLists/PreviewActions";
import { isLegacyPreview } from "utils/Preview";

const PREVIEW = {
	component: ({ libraryId, dependentValues }) => {
		let {  creativeId, versionId } = dependentValues;
		return(<LinkAction
			key="preview-version"
			name="Preview"
			iconName="preview"
			iconStyle="far"
			tooltipContent="Preview"
			path={`/library/${libraryId}/creative/${creativeId}/versions/${versionId}/modal/preview-version/`} />
		);
	},
};

const PREVIEW_CREATIVE_PRIVATE = {
	name:"Preview Creative (Private)",
	// shouldDisplay:({ dependentValues })=>{return shouldDisplayAction.privateCreativePreview(dependentValues);},
	component: ({ dependentValues }) => {
		const creative = useSelector(state => state.creativeDetails);
		const { creativeId, versionName } = dependentValues || {};

		return (
			<BasicAction
				className="external-link-action preview-actions"
				iconName="fas fa-image"
				name="Preview Creative (Private)"
				handleClick={() => {
					if(isLegacyPreview(creative)){
						legacyPreviewVersion(creativeId, versionName);
					} else {
						previewVersion(creativeId, versionName);
					}
				}}
			/>
		);
	},
};

export const VERSIONS_PREVIEW_ACTIONS = [
	PREVIEW,
	PREVIEW_CREATIVE_PRIVATE,
];

export const PRIVATE ={
	PREVIEW
	, PREVIEW_CREATIVE_PRIVATE,
};
